import { render } from "./App.vue?vue&type=template&id=33239639"
const script = {}

import "./App.vue?vue&type=style&index=0&id=33239639&lang=css"

import exportComponent from "C:\\Users\\Hardcore\\Documents\\LEARNING\\VUE PROJECT\\movie-review\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__